import ActionType from '@actions/type';
import { combineReducers } from 'redux';
import Ready from '@consts/ready';

function epassportHeight(state = {
  hasEpassErr: false,
}, action) {
  switch (action.type) {
    case ActionType.EPASSPORT_HEIGHT_RESIZE:
      return {
        ...state,
        hasEpassErr: true,
        hasEpassErrWithCode: action.code,
      };
    default:
      return state;
  }
}

function exportDialogData(state = {
  display: false,
  readyState: Ready.UNSET,
  message: null,
}, action) {
  switch (action.type) {
    case ActionType.EPASSPORT_SHOW_EXPORT_DIALOG:
      return {
        ...state,
        display: true,
      };
    case ActionType.EPASSPORT_HIDE_EXPORT_DIALOG:
      return {
        display: false,
        message: null,
        readyState: Ready.UNSET,
      };
    case ActionType.EPASSPORT_EXPORT_DATA_LOADING:
      return {
        ...state,
        readyState: Ready.LOADING,
      };
    case ActionType.EPASSPORT_EXPORT_DATA_SUCCESS:
      return {
        ...state,
        readyState: Ready.SUCCESS,
        display: false,
      };
    case ActionType.EPASSPORT_EXPORT_DATA_FAIL:
      return {
        ...state,
        readyState: Ready.FAIL,
        message: action.error,
      };
    case ActionType.EPASSPORT_HEIGHT_RESIZE:
      return {
        ...state,
        hasEpassErr: true,
        hasEpassErrWithCode: action.code,
      };
    default:
      return state;
  }
}

export default combineReducers({
  exportDialogData,
  epassportHeight,
});



// WEBPACK FOOTER //
// ./reducers/epassport.js